<script setup>
const { isAuthenticated, hasProviderId } = useSessionData()
</script>

<template>
  <AppLogoutButton v-if="isAuthenticated" />
  <AppLoginButton v-else-if="!isAuthenticated && hasProviderId" />
</template>
